
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-portal/get-started",
      function () {
        return require("private-next-pages/community-portal/get-started.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-portal/get-started"])
      });
    }
  